
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

const orderModule = getModule(OrderModule);

@Component
export default class OrderTable extends Vue {
  getFields: any[];
  pendingOrderActions: number[] = [];
  completedOrderActions: number[] = [];

  @Prop({ required: false, default: null })
  fields: string[];

  @Prop({ default: [] })
  items: any[];

  @Prop({ default: "No orders found", required: false })
  noOrdersMessage: string;

  @Prop({ default: false, required: false })
  selectable: boolean;

  @Prop({ default: null, required: false })
  actionText: string;

  @Prop({ default: null, required: false })
  actionCompleteIcon: string;

  @Prop({ default: null, required: false })
  actionIcon: string;

  @Prop({ default: false, required: false })
  loading: boolean;

  @Prop({ default: null, required: false })
  actionHandler: Function;

  @Prop({ default: true, required: false })
  sticky: boolean;

  @Prop({ default: false, required: false })
  canOpen: boolean;

  @Prop({ default: null, required: false })
  loadMoreHandler: Function;

  get applicableFields() {   
    if (this.fields) {
      return this.fields.map(x => orderModule.getAvailableOrderFields.filter(y => x === y.key)[0]).filter(x => x !== undefined && x !== null);
    }

    return orderModule.getAvailableOrderFields;
  }

  handleSelected(value, item) {
    this.$emit("selected", { item, selected: value });
  }

  get hasAction(): boolean {
    return this.actionText !== null || this.actionIcon !== null;
  }

  get hasLoadMoreAction(): boolean {
    return this.loadMoreHandler != null
  }

  getValue(object, path) {
    if (!path) return;

    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }

  onDoubleClicked(orderData) {
    if (!this.canOpen) return;

    let orderNumber = orderData.number;
    this.$router.push(`/order/${orderNumber}`);
  }

  actionSelected(row) {
    if (this.actionHandler) {
      this.pendingOrderActions.push(+row.number);
      Promise.resolve(this.actionHandler(row))
        .then(() => {
          this.pendingOrderActions.splice(
            this.pendingOrderActions.findIndex(x => x == row.number),
            1
          );
          this.completedOrderActions.push(+row.number);
        })
        .catch(ex => {
          this.pendingOrderActions.splice(
            this.pendingOrderActions.findIndex(x => x == row.number),
            1
          );
        });
    }

    this.$emit("action", row);
  }

  loadMore() {
    if(this.loadMoreHandler) {
      this.loadMoreHandler();
    }
    this.$emit("loadMore");
  }

  orderHasPendingAction(orderNumber: number): boolean {
    return this.pendingOrderActions.indexOf(orderNumber) > -1;
  }

  orderHasCompletedAction(orderNumber: number): boolean {
    return this.completedOrderActions.indexOf(orderNumber) > -1;
  }
}
